/** Position dans la vidéo, au format de la timeline Evergreen : `mm:ss`, `hh:mm:ss` au-delà d'une heure. */
export function secondsToTimeString(seconds: number): string {
  if (!seconds || !Number.isFinite(seconds)) return '00:00';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) {
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
